import { render } from "./my.badge.vue?vue&type=template&id=4147a036"
import script from "./my.badge.vue?vue&type=script&lang=js"
export * from "./my.badge.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__